import { useMemo } from "react";
import { Tag } from "@sprout/tag";
import { SecondaryBody } from "@sprout/typography.tsx";
import useTranslation from "@/hooks/use_translation";

type Props = {
  locations?: string[];
  workType?: string | null;
  payRange?: string;
  secondaryText?: string;
};

const WORK_TYPE_I18N_KEY: Record<string, string> = {
  remote: "workTypeOptions.remote",
  hybrid: "workTypeOptions.hybrid",
  in_person: "workTypeOptions.inPerson",
};

const Tags = ({ locations = [], workType, payRange, secondaryText }: Props) => {
  const { t } = useTranslation("jobSearch");

  const locationTags = useMemo(() => {
    const tags = [...locations];
    if (workType && WORK_TYPE_I18N_KEY[workType]) {
      tags.unshift(t(WORK_TYPE_I18N_KEY[workType]));
    }
    return tags;
  }, [locations, workType, t]);

  return (
    <div className="flex flex-col gap-2 flex-grow min-w-0">
      {locationTags.length > 0 && (
        <div className="flex flex-row gap-2 items-center flex-wrap">
          {locationTags.map((tag, index) => (
            <Tag
              key={index}
              label={tag}
              truncate={false}
              className="whitespace-nowrap"
              maxWidth="max-w-full"
            />
          ))}
        </div>
      )}
      <div className="flex flex-row gap-2 items-center min-h-[1.25rem]">
        {payRange && (
          <Tag
            label={payRange}
            truncate={false}
            maxWidth="max-w-full"
            color="var(--green-50)"
            className="whitespace-nowrap"
          />
        )}
        {secondaryText && <SecondaryBody>{secondaryText}</SecondaryBody>}
      </div>
    </div>
  );
};

export default Tags;
